import React from 'react';
import { Text, Grid, GridItem, useBreakpointValue } from '@chakra-ui/react';
import date from '../../../../../services/ui/date';
import { useTokens } from '../../../../../context/TokenProvider';
import { optionalValue } from '../../../../../services/text/optionalValue';
import { localise } from '../../../../../services/lang/lang';
import { getCreatorName } from '../../../../../services/text/getCreatorName';
const InspectionDetailHeaderSummary = ({ inspection, }) => {
    const tokens = useTokens();
    const breakpoints = useBreakpointValue({
        xl: 'repeat(2, 180px 30ch)',
        md: '180px 30ch',
        sm: '160px 30ch',
    }, {
        fallback: 'xl',
    });
    const gridStyle = {
        columnGap: tokens.Spacing04,
        rowGap: 2,
        gridTemplateColumns: breakpoints,
        reference: {
            speakAs: 'spell-out',
        },
    };
    const { address } = inspection.property;
    const shortAddress = address
        ? `${address.address_1}, ${address.post_code}`
        : localise('DRAFT');
    return (React.createElement(Grid, { sx: gridStyle, tabIndex: 0 },
        React.createElement(GridItem, null,
            React.createElement(Text, { variant: "dk-800-md-3" }, "Inspector:")),
        React.createElement(GridItem, null,
            React.createElement(Text, { tabIndex: 0, "aria-label": `Inspector: ${getCreatorName(inspection)}`, variant: "lt-500-rg-3", "data-testid": "inspection_detail_header_summary__creator_full_name" }, getCreatorName(inspection))),
        React.createElement(GridItem, null,
            React.createElement(Text, { variant: "dk-800-md-3" }, "Status:")),
        React.createElement(GridItem, null,
            React.createElement(Text, { tabIndex: 0, "aria-label": `Status: ${inspection.status.name}`, variant: "lt-500-rg-3", "data-testid": "inspection_detail_header_summary__status_name" }, inspection.status.name)),
        React.createElement(GridItem, null,
            React.createElement(Text, { variant: "dk-800-md-3" }, "Address:")),
        React.createElement(GridItem, null,
            React.createElement(Text, { tabIndex: 0, "aria-label": `Address: ${optionalValue(shortAddress)}`, variant: "lt-500-rg-3", "data-testid": "inspection_detail_header_summary__formatted_address" }, optionalValue(shortAddress))),
        React.createElement(GridItem, null,
            React.createElement(Text, { variant: "dk-800-md-3" }, "Inspection reference:")),
        React.createElement(GridItem, null,
            React.createElement(Text, { tabIndex: 0, sx: gridStyle.reference, "aria-label": `Inspection reference: ${inspection.reference}`, "data-testid": "inspection_detail_header_summary__reference", variant: "lt-500-rg-3" }, inspection.reference)),
        React.createElement(GridItem, null,
            React.createElement(Text, { variant: "dk-800-md-3" }, "Weather conditions:")),
        React.createElement(GridItem, null,
            React.createElement(Text, { tabIndex: 0, "aria-label": `Weather conditions: ${inspection.weather_conditions}`, variant: "lt-500-rg-3", "data-testid": "inspection_detail_header_summary__weather_conditions" }, optionalValue(inspection.weather_conditions))),
        React.createElement(GridItem, null,
            React.createElement(Text, { variant: "dk-800-md-3" }, "Inspection date:")),
        React.createElement(GridItem, null,
            React.createElement(Text, { tabIndex: 0, "aria-label": `Inspection date: ${date.standard(inspection.inspection_date)}`, variant: "lt-500-rg-3", "data-testid": "inspection_detail_header_summary__inspection_date" }, date.standard(inspection.inspection_date)))));
};
export default InspectionDetailHeaderSummary;
